'use client'

import {
  themeBackgroundMap,
  themeBorderColorMap,
  themeDivideColorMap,
} from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { Heading } from '../heading/heading.tsx'
import { Icon } from '../icon/index.ts'
import { ProgressCircle } from '../progress-circle/progress-circle.tsx'
import { Text } from '../text/text.tsx'
import { StepComponent } from './step-component.tsx'

type StepperProps = PropsWithChildren<{
  className?: string
  title: string
  subtitle: string
  completed: number
  total: number
}>

const StepperComponent = ({
  children,
  className,
  title,
  subtitle,
  completed,
  total,
}: StepperProps) => {
  return (
    <div
      className={cn(
        'rounded-xs border-2',
        themeBorderColorMap.muted,
        themeBackgroundMap['container-tertiary'],
        className
      )}
    >
      <div className="flex">
        <div
          className={cn(
            'max-md:hidden border-r-2 w-40',
            themeBorderColorMap.muted,
            themeBackgroundMap['container-tertiary']
          )}
        >
          <Icon
            className="drop-shadow-glow-blue-light"
            name="RocketUpIcon"
            size="full"
          />
        </div>

        <div className={cn('w-full divide-y', themeDivideColorMap.muted)}>
          <div className="flex items-center justify-between gap-4 px-8 py-4">
            <div className="flex flex-col gap-1 w-full">
              <Heading fontSize="2xl" fontWeight="bold" textColor="primary">
                {title}
              </Heading>

              <Text fontSize="base" fontWeight="medium" textColor="secondary">
                {subtitle}
              </Text>
            </div>

            <ProgressCircle completed={completed} total={total} size="med" />
          </div>

          <div className="px-8 py-4">{children}</div>
        </div>
      </div>
    </div>
  )
}

const StepperNamespace = Object.assign(StepperComponent, {
  Step: StepComponent,
})

export { StepperNamespace as Stepper, type StepperProps }
